import { useNavigate } from 'react-router-dom';
import { PATH_PAGE } from "../routes/paths";
import useAuth from "../hooks/useAuth";
// @types
import { Profile } from './../@types/user';
import { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";

let timeoutHandler: ReturnType<typeof setTimeout> | null = null;
let popupHandler: ReturnType<typeof setTimeout> | null = null;
let onMouseInteract: (e: MouseEvent) => void;


export default function ActivityWatcher() {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);

  let { user, logout } = useAuth();

  user = user as Profile;

  const handleClosePopup = () => {
    setPopup(false);
  };

  useEffect(() => {
    if (user === null) {
      if (timeoutHandler !== null) {
        clearTimeout(timeoutHandler);
      }

      if (popupHandler !== null) {
        clearTimeout(popupHandler);
      }

      return;
    }

    onMouseInteract = (e: MouseEvent) => {
      watchTimeout();
    };

    let watchTimeout = () => {
      if (timeoutHandler !== null) {
        clearTimeout(timeoutHandler);
      }

      if (popupHandler !== null) {
        clearTimeout(popupHandler);
      }

      timeoutHandler = setTimeout(() => {
        setPopup(false);
        window.removeEventListener("click", onMouseInteract, false);
        logout();
        navigate(PATH_PAGE.sessionInactive, { replace: true });
      }, user?.userMaxInactivity * 1000);


      popupHandler = setTimeout(() => {
        setPopup(true);
      }, (user?.userMaxInactivity - 10) * 1000);
    }

    watchTimeout();
    window.addEventListener("click", onMouseInteract);

  }, [user]);


  return (<Dialog fullWidth maxWidth="xs" open={popup} onClose={handleClosePopup}>
    <DialogTitle sx={{ pb: 2 }}>Session Inactive</DialogTitle>

    <DialogContent sx={{ typography: 'body2' }}>Due to inactivity, you will be logged out of the system in a moment. If
      you want to stay in MediOMXv2 press "OK"</DialogContent>

    <DialogActions>
      <Stack alignItems="flex-start" sx={{ mt: 3 }} direction="row" spacing={2}>
        <Button variant="outlined" color="inherit" onClick={handleClosePopup}>
          OK
        </Button>
      </Stack>
    </DialogActions>
  </Dialog>);
}

